import React from "react";
import { toast } from "sonner";
import { Share2, Copy, MessageCircle, Award } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function ShareKindCard({ title, subtitle }) {
  const { user } = useApp();
  const ref = user?.referral_code || user?.referral || "";
  const url = `${window.location.origin}/?ref=${ref}`;
  const msg = `${title}${subtitle ? ` — ${subtitle}` : ""} 🌿 on My Kind. Join me: ${url}`;
  const wa = () => window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
  const copy = () => { navigator.clipboard.writeText(msg); toast.success("Copied — paste anywhere!"); };
  const native = async () => { if (navigator.share) { try { await navigator.share({ title: "My Kind", text: msg, url }); } catch { /* ignore */ } } else copy(); };
  return (
    <div className="mt-4 rud-card rounded-2xl overflow-hidden" data-testid="kind-card">
      <div className="p-6 bg-elevated relative overflow-hidden">
        <div className="absolute -top-10 -right-8 w-40 h-40 brand-glow rounded-full pointer-events-none" />
        <div className="relative flex items-center gap-2 text-brand text-xs uppercase tracking-widest"><Award size={13} /> My Kind · Kind Card</div>
        <div className="relative font-serif text-2xl mt-2">{title}</div>
        {subtitle && <div className="relative text-sec text-sm mt-1">{subtitle}</div>}
      </div>
      <div className="p-4 flex flex-wrap gap-2">
        <button data-testid="kindcard-share" onClick={native} className="btn-primary rounded-full h-9 px-4 text-sm flex items-center gap-1.5"><Share2 size={14} /> Share</button>
        <button data-testid="kindcard-whatsapp" onClick={wa} className="btn-ghost rounded-full h-9 px-4 text-sm flex items-center gap-1.5"><MessageCircle size={14} /> WhatsApp</button>
        <button data-testid="kindcard-copy" onClick={copy} className="btn-ghost rounded-full h-9 px-4 text-sm flex items-center gap-1.5"><Copy size={14} /> Copy</button>
      </div>
    </div>
  );
}
